import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessor } from '@ngneat/reactive-forms';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { Agent, AgentService } from 'src/app/apis/agent.service';
import { AppCore } from 'src/app/utils/classes/app-core';
import { AppSort } from 'src/app/utils/constants/app-sort';
import { formPage } from 'src/app/utils/functions/form-page';

@Component({
  selector: 'app-agent-select-agent-downline-from',
  templateUrl: './agent-select-agent-downline-from.component.html',
  styleUrls: ['./agent-select-agent-downline-from.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgentSelectAgentDownlineFromComponent),
      multi: true,
    },
  ],
})
export class AgentSelectAgentDownlineFromComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() agentType: string;
  @Input() agentCode: string;
  agentTypeId: number;
  value = undefined;

  agent$: Observable<Agent[]>;
  agentLoading = false;
  agentInput$ = new Subject<string>();

  @Output() agentChange = new EventEmitter();
  constructor(private svAgent: AgentService) {}

  ngOnInit(): void {
    this.agentTypeId = this.svAgent.agentTypes.find((c) => c.typeName === this.agentType)?.typeId;

    this.agent$ = concat(
      of([]),
      this.agentInput$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => (this.agentLoading = true)),
        switchMap((term) => {
          if (!term || !term.trim()) {
            this.agentLoading = false;
            return of([]);
          }

          const form = formPage({
            typeAgentId: this.agentTypeId || '',
            order_by: '',
            name: 'agent_name',
            sort: AppSort.Asc,
            filter: term,
            agent_code: this.agentCode,
          });
          return this.svAgent.getAgentDownline1lvl(form.getRawValue()).pipe(
            map((res) => this.sortAgentItems(res?.items || [])),
            catchError(() => of([])),
            tap(() => (this.agentLoading = false))
          );
        })
      )
    );
  }

  ngOnDestroy(): void {}

  writeValue(val: any): void {
    this.value = val;
  }
  onChange?: (value: any) => void;

  onTouched?: () => void;

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  trackAgentByFn(item: Agent) {
    return item.id;
  }

  selectAgentChange(event: Agent | undefined) {
    this.agentChange.emit(event);
  }

  sortAgentItems(items: Agent[]) {
    return items.sort((a, b) => {
      const aName = a.agent_name.toUpperCase();
      const bName = b.agent_name.toUpperCase();
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    });
  }
}
